"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _FieldRenderer = _interopRequireDefault(require("../FieldRenderer"));
var _utils = require("../utils");
var _constants = require("../constants");
var _StorybookContext = require("../contexts/StorybookContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var FieldGroup = props => {
  var {
    heading = '',
    subheading = '',
    fields = [],
    fieldValues = {},
    inverse = false,
    language = _constants.CONTENTFUL_LOCALE.en,
    clickedSubmit = false,
    mobileWidth = _constants.FIELD_WIDTH.DEFAULT,
    tabletWidth = _constants.FIELD_WIDTH.DEFAULT,
    desktopWidth = _constants.FIELD_WIDTH.DEFAULT,
    fieldReferences = {},
    fieldData,
    isConditionalField = false,
    removeSpacing = false,
    preFillValues = {},
    isProduction = false,
    environment = 'sandbox',
    leadingSpace = 2,
    trailingSpace = 4
  } = props;
  var storybookContext = (0, _react.useContext)(_StorybookContext.StorybookContext);
  var {
    testFieldGroupLeadingSpace,
    testFieldGroupTrailingSpace
  } = storybookContext;
  var renderedFields = fields.map(field => _FieldRenderer.default.renderField(field, fieldValues, preFillValues, language, clickedSubmit,
  // Add safety check here
  field.id && fieldReferences ? fieldReferences[field.id] || null : null, fieldData, null, isProduction, environment)).filter(field => field !== undefined);
  var boxSection = /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    tag: "section",
    top: testFieldGroupLeadingSpace !== null && testFieldGroupLeadingSpace !== void 0 ? testFieldGroupLeadingSpace : leadingSpace,
    bottom: testFieldGroupTrailingSpace !== null && testFieldGroupTrailingSpace !== void 0 ? testFieldGroupTrailingSpace : trailingSpace,
    testID: "field-group-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.StackView, {
    space: 0
  }, heading !== '' && /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
    block: true,
    heading: "h2",
    variant: {
      size: 'h2',
      inverse
    }
  }, heading), subheading !== '' && /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
    block: true,
    variant: {
      size: 'large',
      inverse
    }
  }, subheading)), /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid, {
    outsideGutter: false,
    tag: 'header'
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Row, null, renderedFields)));

  // Conditional Fields have extra padding coming from the parent fieldOption so we have to render it without FlexGrid
  // when removeSpacing is true
  return removeSpacing || isConditionalField ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, boxSection) :
  /*#__PURE__*/
  // Render a FieldGroup that is not a conditionaFieldGroup with FlexGrid and variable for spacing determined by removeSpacing
  _react.default.createElement(_componentsWeb.FlexGrid.Row, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Col, {
    xs: (0, _utils.fieldWidthsToFlexGridSizes)(mobileWidth),
    md: (0, _utils.fieldWidthsToFlexGridSizes)(tabletWidth),
    lg: (0, _utils.fieldWidthsToFlexGridSizes)(desktopWidth)
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.Spacer, {
    space: 5
  }), boxSection));
};
FieldGroup.propTypes = {
  heading: _propTypes.default.string,
  subheading: _propTypes.default.string,
  mobileWidth: _propTypes.default.oneOf(_constants.FIELD_WIDTH_OPTIONS),
  tabletWidth: _propTypes.default.oneOf(_constants.FIELD_WIDTH_OPTIONS),
  desktopWidth: _propTypes.default.oneOf(_constants.FIELD_WIDTH_OPTIONS),
  fields: _propTypes.default.array,
  fieldValues: _propTypes.default.object,
  clickedSubmit: _propTypes.default.bool,
  language: _propTypes.default.string,
  inverse: _propTypes.default.bool,
  fieldReferences: _propTypes.default.object,
  preFillValues: _propTypes.default.object,
  isProduction: _propTypes.default.bool,
  environment: _propTypes.default.string,
  spacing: _propTypes.default.oneOf(_constants.FORM_SPACING_OPTIONS),
  leadingSpace: _propTypes.default.oneOf(_constants.UDS_SPACING_OPTIONS),
  trailingSpace: _propTypes.default.oneOf(_constants.UDS_SPACING_OPTIONS),
  removeSpacing: _propTypes.default.bool
};
var _default = exports.default = FieldGroup;